export default __webpack_public_path__ + "static/15-38347db37d3566af5b2e64a4a9c2f073.webp";